import { FC } from 'react';
import { isAuthorizedAtom, backgroundColorAtom } from '@/lib/store/Contentstore';
import { Outlet } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import Navigation from '../Navigation/Navigation';
import styles from './Main.module.css';

const Main: FC = () => {
  const useSecondaryBackgroundColor = useAtomValue(backgroundColorAtom);
  const isAuthorized = useAtomValue(isAuthorizedAtom);

  return (
    <main className={`${styles.main} ${useSecondaryBackgroundColor ? styles.bgsecondary : styles.bgprimary}`}>
      {isAuthorized && (
        <aside className={styles.aside}>
          <Navigation />
        </aside>
      )}
      <div className={styles.container}>
        <Outlet />
      </div>
    </main>

  );
};

export default Main;
